import _ from '@app/utils.js'

// TODO: sostituire gli URL segnaposto con i profili social reali
const SOCIAL_LINKS = [
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/',
    icon: '<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.78-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.44 2.89h-2.34v6.99A10 10 0 0 0 22 12z"/></svg>',
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/',
    icon: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg>',
  },
  {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/',
    icon: '<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.45 20.45h-3.56v-5.57c0-1.33-.03-3.04-1.85-3.04-1.86 0-2.14 1.45-2.14 2.94v5.67H9.34V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.56V9h3.56v11.45z"/></svg>',
  },
  {
    name: 'YouTube',
    url: 'https://www.youtube.com/',
    icon: '<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 0 0 .5 6.2C0 8.1 0 12 0 12s0 3.9.5 5.8a3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1c.5-1.9.5-5.8.5-5.8s0-3.9-.5-5.8zM9.6 15.6V8.4l6.2 3.6-6.2 3.6z"/></svg>',
  },
]

_.onElementArrive('header', header => {
  const body = document.querySelector('body')
  const hamburger = header.querySelector('.hamburger-trigger')
  if (!hamburger) return

  // ── Build the drawer ────────────────────────────────────────────────────
  const drawer = document.createElement('div')
  drawer.className = 'mobile-nav-drawer'
  drawer.id = 'mobile-nav-drawer'
  drawer.setAttribute('aria-label', Drupal.tt('Navigazione mobile'))
  drawer.setAttribute('role', 'navigation')

  // Header row: logo + close button
  const drawerHeader = document.createElement('div')
  drawerHeader.className = 'mobile-nav-header'

  const logoSource = header.querySelector('.logo')
  if (logoSource) {
    const logoClone = logoSource.cloneNode(true)
    logoClone.className = 'mobile-nav-logo'
    drawerHeader.appendChild(logoClone)
  }

  const closeBtn = document.createElement('button')
  closeBtn.className = 'mobile-nav-close hamburger-trigger active'
  closeBtn.setAttribute('aria-label', Drupal.tt('Chiudi menu'))
  closeBtn.innerHTML = '<span></span><span></span><span></span>'
  drawerHeader.appendChild(closeBtn)

  drawer.appendChild(drawerHeader)

  // Clone main menu
  const desktopMenu = header.querySelector('.main-menu')
  if (desktopMenu) {
    const menuClone = desktopMenu.cloneNode(true)
    menuClone.classList.remove('main-menu')
    menuClone.classList.add('mobile-main-menu')

    // Wire up submenu toggles on the clone
    menuClone.querySelectorAll('.level-1 > li').forEach(li => {
      const trigger = li.querySelector(':scope > span')
      const sublevel = li.querySelector('.level-2')
      if (trigger && sublevel) {
        trigger.addEventListener('click', () => li.classList.toggle('open'))
      }
    })

    drawer.appendChild(menuClone)
  }

  // Actions row: clones of myDIEMMEBI, cart, language
  const actions = document.createElement('div')
  actions.className = 'mobile-nav-actions'

  // myDIEMMEBI sits above the actions border, right below the main menu
  const myDiemmebiTrigger = header.querySelector('.my-diemmebi-trigger')
  let myDiemmebiRow = null
  if (myDiemmebiTrigger) {
    const clone = myDiemmebiTrigger.cloneNode(true)
    // Clicking myDIEMMEBI in mobile drawer: close mobile menu first, then open submenu
    clone.addEventListener('click', () => {
      closeMobileMenu()
      myDiemmebiTrigger.click()
    })
    myDiemmebiRow = document.createElement('div')
    myDiemmebiRow.className = 'mobile-nav-my-diemmebi'
    myDiemmebiRow.appendChild(clone)
  }

  const social = document.createElement('div')
  social.className = 'mobile-nav-social'
  SOCIAL_LINKS.forEach(({name, url, icon}) => {
    const a = document.createElement('a')
    a.href = url
    a.target = '_blank'
    a.rel = 'noopener noreferrer'
    a.setAttribute('aria-label', name)
    a.innerHTML = icon
    social.appendChild(a)
  })
  actions.appendChild(social)

  const cartTrigger = header.querySelector('.cart-trigger')
  if (cartTrigger) {
    actions.appendChild(cartTrigger.cloneNode(true))
  }

  const langTrigger = header.querySelector('.language-trigger')
  if (langTrigger) {
    const clone = langTrigger.cloneNode(true)
    clone.addEventListener('click', () => {
      closeMobileMenu()
      langTrigger.click()
    })
    actions.appendChild(clone)
  }

  if (myDiemmebiRow) drawer.appendChild(myDiemmebiRow)
  drawer.appendChild(actions)
  document.body.appendChild(drawer)

  // ── Adatta il top alla toolbar admin (Gin) se presente ───────────────────
  const syncAdminToolbarOffset = () => {
    const toolbar = document.getElementById('gin-toolbar-bar')
    drawer.style.top = toolbar ? `${toolbar.offsetHeight}px` : ''
  }
  syncAdminToolbarOffset()
  window.addEventListener('resize', syncAdminToolbarOffset)

  // ── Open / close helpers ─────────────────────────────────────────────────
  const openMobileMenu = () => {
    drawer.classList.add('open')
    hamburger.classList.add('active')
    hamburger.setAttribute('aria-expanded', 'true')
    body.classList.add('mobile-nav-open')
  }

  const closeMobileMenu = () => {
    drawer.classList.remove('open')
    hamburger.classList.remove('active')
    hamburger.setAttribute('aria-expanded', 'false')
    body.classList.remove('mobile-nav-open')
  }

  // ── Event listeners ──────────────────────────────────────────────────────
  hamburger.addEventListener('click', () => {
    drawer.classList.contains('open') ? closeMobileMenu() : openMobileMenu()
  })

  closeBtn.addEventListener('click', closeMobileMenu)

  // Populate .my-diemmebi-mobile-header with logo + X (mirrors .mobile-nav-header)
  const myDiemmebiMenu = header.querySelector('.my-diemmebi-menu')
  const myDiemmebiMobileHeader = myDiemmebiMenu?.querySelector('.my-diemmebi-mobile-header')
  if (myDiemmebiMobileHeader) {
    if (logoSource) {
      const logoClone = logoSource.cloneNode(true)
      logoClone.className = 'mobile-nav-logo'
      myDiemmebiMobileHeader.appendChild(logoClone)
    }

    const closeBtn = document.createElement('button')
    closeBtn.className = 'mobile-nav-close hamburger-trigger active'
    closeBtn.setAttribute('aria-label', Drupal.tt('Chiudi'))
    closeBtn.innerHTML = '<span></span><span></span><span></span>'
    closeBtn.addEventListener('click', () => {
      myDiemmebiMenu.classList.remove('header-submenu-open')
      body.classList.remove('menu-open')
      openMobileMenu()
    })
    myDiemmebiMobileHeader.appendChild(closeBtn)
  }

  // Close on anchor links (same-page navigation)
  drawer.querySelectorAll('a[href*="#"]').forEach(link => {
    link.addEventListener('click', closeMobileMenu)
  })

  // Close on Escape
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && drawer.classList.contains('open')) closeMobileMenu()
  })
})
